import PDFDocument from 'pdfkit/js/pdfkit.standalone.js'
import PdfTable from 'voilab-pdf-table'
import fitColumn from 'voilab-pdf-table/plugins/fitcolumn'
import moment from 'moment-timezone'

import logo from '/assets/images/smartix-logo.png'

const getInvoicePDF = async (invoice,variables) => {
  return new Promise(async function(resolve,reject){
    try
    {
      let invoice_logo = await importImageAsBase64(logo)

      const addressLines = variables.companyAddress.split("\n").length

      // Create a document
      const doc = new PDFDocument({size:'A4',  margin:20})
      const chunks = []

      doc.on("data", (chunk) => chunks.push(chunk))
      doc.on("end", () => {
        const pdfBlob = new Blob(chunks, { type: "application/pdf" })
        resolve(pdfBlob)
      })

      // Company name and address
      doc.font('Helvetica')
      .fontSize(14)
      .fillColor(variables.highlightColour)
      .text(variables.companyName,{align:'right'})
      .fillColor('black')
      .fontSize(10)
      .text(variables.companyAddress,{align:'right'})
      .moveDown()
      .fillColor(variables.highlightColour)
      .text(variables.companyEmail,{align:'right'})
      .moveUp(addressLines + 2)

      const linkY = doc.y

      // Measure the text
      const linkwidth = doc.widthOfString(variables.companyEmail)
      const linkheight = doc.currentLineHeight()

      doc.link(doc.page.width - doc.page.margins.right - linkwidth, linkY, linkwidth, linkheight, 'mailto:' + variables.companyEmail)
      .fillColor('black')

      // Company Logo
      .image(invoice_logo,{
        fit: [200, 50],
        align: "center",
        valign: "center"
      })

      .moveDown(3)

      // INVOICE
      .font('Helvetica-Bold')
      .fontSize(24)
      .fillColor(variables.highlightColour)
      .text('INVOICE',{align:'center'})
      .font('Helvetica')
      .fillColor('black')
      .fontSize(10)

      // Company & VAT registration numbers
      doc.rect(0,160,doc.page.width,35).stroke('#ccc')
      .moveDown()
      .font('Helvetica')
      .text('Registered in England & Wales : ',20,175,{continued:true})
      .font('Helvetica-Bold')
      .fillColor(variables.highlightColour)
      .text(variables.companyNumber)
      .moveUp()
      .text(variables.vatNumber,{align:'right'})
      .moveUp()
      .fillColor('black')

      const titleWidth = doc.widthOfString('VAT Number : ')
      const contentWidth = doc.widthOfString(variables.vatNumber)
      const titlePos = doc.page.width - doc.page.margins.right - titleWidth - contentWidth

      doc.font('Helvetica')
      .text('VAT Number : ',titlePos,doc.y)
      .moveDown()
     
      doc.x = 20
      doc.y += 20

      let addressTop = doc.y
      let invoicedate = moment(invoice.invoice_date,"YYYY-MM-DD").format('DD MMM YYYY')

      doc.font('Helvetica-Bold')
      .text(invoice.clientName)
      .font('Helvetica')
      .text(invoice.clientAddress.replace(/\r/g,''))

      doc.font('Helvetica-Bold')
      .fillColor(variables.highlightColour)
      .text(invoicedate,0,addressTop,{align:'right'})
      .text(invoice.invoicenumber,{align:'right'})
      .fillColor('black')
      .moveUp(2)

      const title2Width = doc.widthOfString('Invoice date : ')
      const content2Width = doc.widthOfString(invoicedate)
      const title2Pos = doc.page.width - doc.page.margins.right - title2Width - content2Width

      const title3Width = doc.widthOfString('Invoice number : ')
      const content3Width = doc.widthOfString(invoice.invoicenumber)
      const title3Pos = doc.page.width - doc.page.margins.right - title3Width - content3Width

      doc.font('Helvetica')
      .text('Invoice date : ',title2Pos,doc.y)
      .text('Invoice number : ',title3Pos,doc.y)

      doc.x = 20
      doc.y += 50

      const table = new PdfTable(doc)

      table.addPlugin(new fitColumn({
        column: 'details'
      }))
      // set defaults to your columns
      .setColumnsDefaults({
          headerBorder: 'B',
          border: 'BT',
          align: 'right',
          padding : [ 10, 0, 10, 0 ],
      })
      .addColumns([
        {
          id: 'details',
          header: '',
          align: 'left',
          cache: false,
          renderer: function (tb, data, draw ) {

            if (draw && data.details === "TOTAL")
            {
              tb.pdf.font('Helvetica-Bold')
              tb.pdf.fillColor(variables.highlightColour)
              tb.pdf.fontSize(10)
            }
            else
            {
              tb.pdf.font('Helvetica')
              tb.pdf.fillColor('black')
              tb.pdf.fontSize(8)
            }

            return data.details.replace(/\r/g,'')
          }
        },
        {
          id: 'netAmount',
          header: 'Net',
          width: 80,
          cache: false,
          renderer: function (tb, data, draw) {

            if (draw && data.details === "TOTAL")
            {
              tb.pdf.font('Helvetica')
              tb.pdf.fillColor(variables.highlightColour)
              tb.pdf.fontSize(10)
            }
            else
            {
              tb.pdf.font('Helvetica')
              tb.pdf.fillColor('black')
              tb.pdf.fontSize(8)
            }

            return new Intl.NumberFormat('gb-GB', {
              style: 'currency',
              currency: 'GBP',
            }).format(data.amount)
          }
        },
        {
          id: 'VAT',
          header: 'VAT',
          width: 80,
          cache: false,
          renderer: function (tb, data, draw) {

            if (draw && data.details === "TOTAL")
            {
              tb.pdf.font('Helvetica')
              tb.pdf.fillColor(variables.highlightColour)
              tb.pdf.fontSize(10)
            }
            else
            {
              tb.pdf.font('Helvetica')
              tb.pdf.fillColor('black')
              tb.pdf.fontSize(8)
            }

            return new Intl.NumberFormat('gb-GB', {
              style: 'currency',
              currency: 'GBP',
            }).format(data.vat)
          }
        },
        {
            id: 'grossAmount',
            header: 'Gross',
            width: 80,
            cache: false,
            renderer: function (tb, data, draw) {
 
              tb.pdf.font('Helvetica-Bold')
              
              if (draw && data.details === "TOTAL")
              {
                tb.pdf.fillColor(variables.highlightColour)
                tb.pdf.fontSize(10)
              }
              else
              {
                tb.pdf.fillColor('black')
                tb.pdf.fontSize(8)
              }

              return new Intl.NumberFormat('gb-GB', {
                style: 'currency',
                currency: 'GBP',
              }).format(data.amount + data.vat)
            }
        }
      ])

      table.onPageAdded(function (tb) {
        tb.addHeader();
      })

      let details = invoice.details.concat({
        details : "TOTAL",
        amount : invoice.amount,
        vat : invoice.vat,
        grossAmount : invoice.total,
      })

      table.addBody(details)

      doc.x = 20
      doc.y += 20

      const termsHeight = 150

      if (doc.page.height - doc.y < termsHeight)
      {
        doc.addPage()
      }

      doc.fillColor('black')
      .fontSize(10)
      .text("Terms : " + variables.invoiceTerms,{align:'center'})
      .moveDown()

      let topOfPaymentDetail = doc.y

      doc.font('Helvetica')
      .text('Please make payment of ',{continued:true})
      .font('Helvetica-Bold')
      .fillColor(variables.highlightColour)
      .text(new Intl.NumberFormat('gb-GB', {
        style: 'currency',
        currency: 'GBP',
      }).format(invoice.total),{continued:true})
      .font('Helvetica')
      .fillColor('black')
      .text(' to:')
      .moveDown()

      let accountNameY = doc.y

      doc.text('Account name : ')

      let sortCodeNumY = doc.y

      doc.text('Sort Code : ')

      let accountNumY = doc.y

      doc.text('Account Number : ')

      let referenceY = doc.y

      doc.text('Reference : ')

      doc.font('Helvetica-Bold')
      .fillColor(variables.highlightColour)
      .text(variables.bankAccountName,130,accountNameY)
      .text(variables.invoiceSortCode,130,sortCodeNumY)
      .text(variables.invoiceAccountNumber,130,accountNumY)
      .text(invoice.invoicenumber,130,referenceY)

      .font('Helvetica')
      .fillColor('black')
      .text("Please send remittance advice to:",0,topOfPaymentDetail,{align:'right'})
      .moveDown()
      .fillColor(variables.highlightColour)
      .text(variables.companyName,{align:'right'})
      .fillColor('black')
      .text(variables.remittanceAddress.replace(/\r/g,''),{align:'right'})

      doc.end()
    }
    catch(err)
    {
      console.log(err)
      reject(err)
    }
  })
}


export default getInvoicePDF

export async function importImageAsBase64(importedUrl) {
  const res = await fetch(importedUrl)
  const blob = await res.blob()
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result) // base64 string
    reader.onerror = reject
    reader.readAsDataURL(blob)
  });
}
